<template>
  <div
    class="fade page-sidebar-fixed page-header-fixed show page-container"
    v-if="authenticated && !pageOptions.pageEmpty"
    v-bind:class="{
      'page-sidebar-minified': pageOptions.pageSidebarMinified,
      'page-content-full-height': pageOptions.pageContentFullHeight,
      'page-without-sidebar': pageOptions.pageWithoutSidebar,
      'page-with-right-sidebar': pageOptions.pageWithRightSidebar,
      'page-with-two-sidebar': pageOptions.pageWithTwoSidebar,
      'page-with-wide-sidebar': pageOptions.pageWithWideSidebar,
      'page-with-light-sidebar': pageOptions.pageWithLightSidebar,
      'page-with-top-menu': pageOptions.pageWithTopMenu,
      'page-sidebar-toggled': pageOptions.pageMobileSidebarToggled,
      'page-right-sidebar-toggled':
        pageOptions.pageMobileRightSidebarToggled ||
        pageOptions.pageRightSidebarToggled,
      'has-scroll': pageOptions.pageBodyScrollTop
    }"
  >
    <Header />
    <TopMenu v-if="pageOptions.pageWithTopMenu" />
    <Sidebar v-if="!pageOptions.pageWithoutSidebar" />
    <SidebarRight v-if="pageOptions.pageWithTwoSidebar" />
    <div
      id="content"
      class="content"
      v-bind:class="{
        'content-full-width': pageOptions.pageContentFullWidth,
        'content-inverse-mode': pageOptions.pageContentInverseMode
      }"
    >
      <router-view></router-view>
      <vue-ins-progress-bar></vue-ins-progress-bar>
    </div>
    <Footer v-if="pageOptions.pageWithFooter" />
    <dialogs-wrapper tag="div" />
    <ts-lock-screen v-show="isLock" @reset="resetTimer"></ts-lock-screen>
    <!-- form-action -->
    <a-modal
      v-model="showForm"
      :title="$t('pendingConfirmation.pageTitle')"
      centered
      :zIndex="1020"
      :footer="null"
      width="100%"
      wrap-class-name="full-modal"
    >
      <ts-pending-confirmation />
    </a-modal>
  </div>
  <div v-else-if="authenticated && pageOptions.pageEmpty">
    <router-view></router-view>
    <vue-ins-progress-bar></vue-ins-progress-bar>
    <ts-lock-screen v-show="isLock" @reset="resetTimer"></ts-lock-screen>
  </div>
  <div v-else>
    <router-view></router-view>
    <vue-ins-progress-bar></vue-ins-progress-bar>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Sidebar from './components/sidebar/Sidebar.vue'
import SidebarRight from './components/sidebar-right/SidebarRight.vue'
import Header from './components/header/Header.vue'
import TopMenu from './components/top-menu/TopMenu.vue'
import Footer from './components/footer/Footer.vue'
import PageOptions from './config/PageOptions.vue'

export default {
  name: 'app',
  components: {
    Sidebar,
    SidebarRight,
    Header,
    TopMenu,
    Footer
  },
  data() {
    return {
      pageOptions: PageOptions,
      lock: false,
      lockTimer: null,
      showForm: false,
      events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load']
    }
  },
  mounted() {
    this.$insProgress.finish()
    this.events.forEach(event => {
      window.addEventListener(event, this.resetTimer)
    })

    this.setTimer()
  },
  created() {
    PageOptions.pageBodyScrollTop = window.scrollY

    window.addEventListener('scroll', this.handleScroll)

    this.$insProgress.start()

    this.$router.beforeEach((to, from, next) => {
      this.$insProgress.start()
      next()
    })
    this.$router.afterEach(() => {
      this.$insProgress.finish()
    })
    this.$Notice.config({
      top: 50,
      duration: 5
    })
    this.$Message.config({
      top: 50,
      duration: 5
    })
    this.getFxRate()
    this.fetchData()
  },
  computed: {
    ...mapGetters(['authenticated']),
    ...mapState('pendingConfirmation/pendingConfirmation', [
      'resources',
      'pagination'
    ]),
    isLock() {
      return this.$store.state.isLockScreen
    },
    idleTimeOut() {
      return (
        parseInt(this.$store.state.authUser.sys_setting.idle_time_out) *
        60 *
        1000
      )
    },
    transfer_type: {
      get() {
        return this.$store.state.pendingConfirmation.pendingConfirmation
          .transfer_type
      },
      set(val) {
        this.$store.commit(
          'pendingConfirmation/pendingConfirmation/SET_TRANSFER_TYPE',
          val
        )
      }
    }
  },
  methods: {
    handleScroll: function() {
      PageOptions.pageBodyScrollTop = window.scrollY
    },
    setTimer() {
      if (this.authenticated && process.env.NODE_ENV !== 'development') {
        this.lockTimer = setTimeout(() => {
          this.$store.commit('setIsLock', 1)
          localStorage.setItem('!z_dy#@_____00111$%!@', 1)
        }, this.idleTimeOut)
      }
    },
    resetTimer() {
      clearTimeout(this.lockTimer)
      this.setTimer()
    },
    recieve() {
      this.transfer_type = 'received'
      this.received = 'active'
      this.transfered = ''
      this.fetchData()
    },
    getFxRate() {
      this.$store.dispatch('exchangeRate/currency/getFormViewModel', {
        index: undefined,
        params: {}
      })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'pendingConfirmation/pendingConfirmation/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          if (this.resources.length == 0) {
            if (this.transfer_type == 'transfered') {
              this.transfer_type = 'received'
              this.fetchData()
            }
            this.showForm = false
          } else {
            this.showForm = true
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          // this.$toasted.error(error.message)
        })
    }
  }
}
</script>
<style lang="scss">
.full-modal {
  .ant-modal {
    max-width: 100%;
    top: 0;
    padding-bottom: 0;
    margin: 0;
    overflow: hidden;
  }
  .ant-modal-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh);
  }
  .ant-modal-body {
    flex: 1;
  }
}
</style>
